<script setup>
    import { useI18n } from 'vue-i18n';
    import { computed } from 'vue';
    import forEach from 'lodash-es/forEach';
    import DownloadAssets from "./DownloadAssets.vue";

    const { t } = useI18n();

    const props = defineProps({
        downloadGroup: {
            type: Object,
            required: true,
        },

        index: {
            type: Number,
            required: true,
        },

        productDetails: {
            type: Boolean,
            required: true,
            default: false,
        },
    });

    const isAMSPProduct = computed(() => {
        let isAMSPProduct = false;
        forEach(props.downloadGroup.assets, asset => {
            if (asset.productType == 'GPS-Node' || asset.productType == 'masterProduct'){
                isAMSPProduct = true;
            }
        });

        return isAMSPProduct;
    });

    const hasAssets = computed(() => {
        let isAMSPImage = false;
        if(props.downloadGroup.name == 'Images'){
            forEach(props.downloadGroup.assets, asset => {
                if (asset.productType == 'GPS-Node' || asset.productType == 'masterProduct'){
                    isAMSPImage = true;
                }
            });
        }

        if(isAMSPImage){
            return false;
        }
        else {
            return props.downloadGroup !== null && props.downloadGroup.assets !== null && props.downloadGroup.assets.length > 0;
        }
    });

    const hasName = computed(() => {
        return props.downloadGroup !== null && props.downloadGroup.name !== null && props.downloadGroup.name !== "";
    });

    function toggleCollapse(event) {
        if (!event.target.classList.contains('button')) {
            let $container = event.target.closest(".download-group");
            let $contentContainer = $container.querySelector(".content-container");

            if ($container.classList.contains('is-active')) {
                $container.classList.remove('is-active');
                $contentContainer.classList.add('is-hidden');
            } else if (!$container.classList.contains('is-active')) {
                $container.classList.add('is-active');
                $contentContainer.classList.remove('is-hidden');
            }
        }
    }
</script>

<template>
    <div v-if="hasAssets" class="download-group collapsable " :class="(index === 0) ? 'is-active' : '' ">
        <div v-if="hasName" class="headline-container toggle-collapse" @click.prevent="toggleCollapse($event)">
            <h3 :id='downloadGroup.name.replaceAll(" ",".")' class="title is-3" >
                {{ t("productDetails.Category." + downloadGroup.name.toLowerCase().replaceAll(" ",".")) }}
            </h3>
            <div class="right-container">
                <div class="toggle-icon">
                    <svg class="icon icon-collapse">
                        <use xlink:href="#icon-collapse"/>
                    </svg>
                </div>
            </div>
        </div>
        <div class="download-group-content content-container " :class="(index !== 0) ? 'is-hidden' : '' ">
            <DownloadAssets
                v-for="(downloadAssets, index) in downloadGroup.assets"
                :download-assets="downloadAssets"
                :index="index"
                :product-details="productDetails"
            ></DownloadAssets>
        </div>
    </div>
</template>
